// Standard student-facing copy for the trail's dissertative (question_type 'text') AI feedback,
// shown in place of the evaluator's raw rationale while the NLP model is still being trained.
// The score comes from open_question_feedback.score and is the evaluator's own rubric band:
// 0 = wrong, 1 = partially right, 2 = right (contract confirmed by Gustavo, NLP owner).
export enum OpenQuestionCorrectness {
  Wrong = 0,
  PartiallyRight = 1,
  Right = 2,
}

const OPEN_QUESTION_FEEDBACK_COPY: Record<OpenQuestionCorrectness, string> = {
  [OpenQuestionCorrectness.Right]:
    'Muito bem! Você entendeu o que a questão pedia e explicou com clareza. Continue assim!',
  [OpenQuestionCorrectness.PartiallyRight]:
    'Você está no caminho certo! Sua resposta tem boas ideias, mas ainda dá para explicar melhor. Releia o texto e a pergunta e tente deixar sua resposta mais completa.',
  [OpenQuestionCorrectness.Wrong]:
    'Sua resposta ainda precisa de ajustes. Releia o texto com calma, veja o que a pergunta pede e tente de novo. Você consegue!',
};

// Returns Mari's standard copy for a dissertative score, or null when the score is absent or
// outside 0/1/2 — the caller falls back to the evaluator's own text in that case.
export function getOpenQuestionFeedbackCopy(
  score: number | null | undefined,
): string | null {
  if (score == null) return null;

  return OPEN_QUESTION_FEEDBACK_COPY[score as OpenQuestionCorrectness] ?? null;
}
